<template>
  <div class="azure-configuration-component">
    <a-row style="margin-bottom: 1rem;">
      <a-col :span="12">
        Koppeling ingeschakeld:
        <a-switch default-checked v-model="connectorSetting.active" v-on:change="onConnectorSettingChanged"/>
      </a-col>
      <a-col :span="12" style="text-align: right;">
        <a-popconfirm
            cancel-text="Annuleren"
            ok-text="Ja"
            placement="topRight"
            title="Weet je zeker dat je de integratie opnieuw wil instellen? Alle bestaande instellingen zullen worden verwijderd."
            @confirm="onDestroyConnector"
        >
          <a-button type="danger">Opnieuw instellen</a-button>
        </a-popconfirm>
      </a-col>
    </a-row>

    <h4>Accounts</h4>

    <template v-if="!loadingMailboxes">
      <a-input-search
          placeholder="Zoek op naam of e-mailadres"
          enter-button="Zoeken"
          size="large"
          @search="onSearch"
          style="margin-bottom: 1rem;"
          :allow-clear="true"
      />
      <AzureMailboxConfigurationComponent v-for="mailbox in filteredMailboxes"
                                          v-bind:mailbox="mailbox"
                                          v-bind:key="mailbox.id"
                                          v-bind:display-override="displayOverride"/>
      <template v-if="!hasMailboxes">
        Er zijn geen accounts met e-mail
      </template>
    </template>
    <template v-else>
      <Skeleton class="skeleton" v-bind:loading="true" style="height: 40px; margin-bottom: 1.5rem;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true" style="margin-bottom: 1rem;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true" style="margin-bottom: 1rem;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true" style="margin-bottom: 1rem;"></Skeleton>
    </template>

    <br/>
    <small>* Zie je niet alle account? Dan worden deze mogelijk op de achtergrond nog ingeladen.</small>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../store'
import mailApi from '~/api/mailify'
import userApi from '~/api/user'
import AzureMailboxConfigurationComponent from './AzureMailboxConfigurationComponent'
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: 'AzureConfigurationPageComponent',
  components: {
    AzureMailboxConfigurationComponent,
    Skeleton
  },
  props: {
    connectorSetting: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      loadingMailboxes: true,
      mailboxes: [],
      searchValue: null,
    }
  },
  computed: {
    ...mapGetters({
      // name: '$_mailify/name',
    }),
    hasMailboxes () {
      return this.mailboxes.length > 0
    },
    filteredMailboxes () {
      if (this.searchValue === null || this.searchValue === '') {
        return this.mailboxes
      }

      return this.mailboxes.filter(mailbox =>
          mailbox.name.toLowerCase().indexOf(this.searchValue.toLowerCase()) >= 0
          || mailbox.mail.toLowerCase().indexOf(this.searchValue.toLowerCase()) >= 0
      )
    },
    displayOverride () {
      return this.searchValue !== null && this.searchValue !== ''
    }
  },
  created () {
    const STORE_KEY = '$_mailify'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    mailApi.getMailboxesByConnectorSettingId(this.connectorSetting.id).then(mailboxes => {
      this.mailboxes = mailboxes
    }).finally(() => {
      this.loadingMailboxes = false
    })

    userApi.paginateActive(1, 1000).then(response => {
      let users = {}

      response.data.forEach(user => users[user.id] = user)

      this.setUsers(users)
    })
  },
  methods: {
    ...mapActions('$_mailify', [
      'setUsers',
    ]),
    onConnectorSettingChanged () {
      mailApi.updateConnectorSetting(this.connectorSetting)
    },
    onDestroyConnector () {
      mailApi.deleteConnectorSetting(this.connectorSetting).then(() => {
        location.reload()
      })
    },
    onSearch (query) {
      this.searchValue = query
    }
  }
}
</script>

<style scoped>
.azure-configuration-component {
  border: solid 1px #ccc;
  border-radius: 5px;
  padding: 1.5rem;
  margin: 1rem 0;
  background-color: white;
}

.skeleton {
  border-color: rgb(217, 217, 217);
  border-radius: 4px;
  margin-top: 1rem;
  height: 55px;
  display: block;
}
</style>